import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import {
  Box,
  TextField,
  MenuItem,
  Typography
} from '@material-ui/core'
import { AppButton, Loader } from '../../Components'
import { TableOutline, OutlinedButton } from '../../elements'
import { getTableHeadings, SUPER_ADMIN, ACCOUNT_ADMIN, ACCOUNT_USER, roles } from './constant'
import { useStyles } from './style'
import { useFormik } from 'formik'
import * as yup from 'yup'
import DisplayMessage from '../../Components/DisplayMessage'
import * as messageTypes from '../../utils/messageTypes'
import { COMMON } from '../../utils/constants'
import { userService } from '../../Services/UserService/UserService'
import StatusButton from '../../Components/StatusButton'
import CustomDialog from '../../Components/CustomDialog'
import { SORTORDER } from '../../utils/constants'
import { accountService } from '../../Services/AccountService/AccountService'
import { getCurrentUser } from '../../AppRedux/actions/Auth'

const validationSchema = yup.object({
  isSuperAdmin: yup.boolean(),
  name: yup.string('Enter name').required('Name is required'),
  role: yup.string('Select Role').required('Please select role'),
  account_id: yup.string().when('isSuperAdmin', {
    is: true,
    then: yup.string('Select Account').required('Please select account')
  }),
  email: yup
    .string('Enter email')
    .email('Enter a valid email')
    .required('Email is required'),
  phone: yup
    .string('Enter phone number')
    .matches(/^[+\d\s\-\(\)]{7,20}$/, 'Phone number must be 7-20 characters and may include +, -, spaces, and parentheses')
    .required('Phone number is required')
  ,
})

function Users(props) {
  const classes = useStyles()
  const [tableData, setTableData] = useState([])
  const [addUserModal, setAddUserModal] = useState(false)
  const [allUsers, setAllUsers] = useState([])
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState(messageTypes.INFO)
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [totalCount, setTotalCount] = useState(0)
  const [editData, setEditData] = useState('')
  const [sortBy, setSortBy] = useState('')
  const [sortOrder, setSortOrder] = useState(SORTORDER.ASC)
  const [headings, setHeadings] = useState(getTableHeadings(props.isSuperAdmin, props.isAdmin, props.isViewOnly))
  const [accounts, setAccounts] = useState([])
  const [loading, setLoading] = useState(true)
  const [tableLoading, setTableLoading] = useState(true)
  const [showAccount, setShowAccount] = useState(false)

  const formik = useFormik({
    initialValues: {
      name: editData.name,
      role: editData ? editData.roles[0] : '',
      account_id: editData ? editData.account_id : '',
      email: editData.email,
      phone: editData.phone,
      isSuperAdmin: props.isSuperAdmin,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      addNewUser(values)
      setAddUserModal(false)
      resetForm({ values: '' })
    },
  })

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
  }

  const addNewUser = (values) => {
    let role = []
    const { currentUser } = props
    const method = editData ? 'put' : 'post'
    role.push(values.role)
    setLoading(true)
    const obj = {
      email: values.email,
      account_id: values.account_id || props.currentUser.account_id,
      name: values.name,
      roles: role,
      phone: values.phone,
    }
    userService
      .addNewUser(obj, currentUser.account_id, method)
      .then((userData) => {
        let users = allUsers
        if (editData) {
          allUsers.forEach((user, index) => {
            if (user.email === userData.email) {
              users[index] = { ...user, ...userData }
            }
          })
        } else {
          users.push(userData)
          setTotalCount(totalCount + 1)
        }
        setAllUsers(users)
        setUserTable(users)
        setOpen(true)
        setMessage(editData ? 'User updated successfully' : 'User added successfully')
        setMessageType(messageTypes.SUCCESS)
        setLoading(false)
        if (editData && currentUser.id === editData.email) {
          props.getCurrentUser()
        }
      })
      .catch((error) => {
        setMessage(
          _.get(
            error,
            'data.error.displayMessage',
            'Failed to add user',
          ),
        )
        setMessageType(messageTypes.ERROR)
        setOpen(true)
        setLoading(false)
      })
  }

  const getAllUsers = (account_id, page, rowsPerPage, sortBy, sortOrder) => {
    setLoading(true)
    setTableLoading(true)
    userService
      .getAllUsers(account_id, page, rowsPerPage, sortBy, sortOrder)
      .then((usersData) => {
        setAllUsers(usersData.users_list)
        setUserTable(usersData.users_list)
        setTotalCount(_.get(usersData, 'total_count', 0))
        setLoading(false)
        setTableLoading(false)
      })
      .catch((error) => {
        setMessage(
          _.get(
            error,
            'data.error.displayMessage',
            'Failed to get users',
          ),
        )
        setMessageType(messageTypes.ERROR)
        setOpen(true)
        setLoading(false)
        setTableLoading(false)
      })
  }

  const setUserTable = (userData) => {
    let userTable = []
    userData.map((obj) => {
      let tableObj = [
        {
          id: 'name',
          value: _.get(obj, 'name', ''),
          data: obj,
          handleClick: (obj) => {
            setEditData(obj.data)
            setAddUserModal(true)
          },
        },
        {
          id: 'account.company_name',
          value: _.get(obj, 'account.company_name', '-'),
        },
        {
          id: 'roles.0',
          value: roles[obj.roles[0]],
        },
        {
          id: 'status',
          value: obj.is_enabled ? <StatusButton text='Active' color='#7acf38' /> : !props.isAdmin ? <StatusButton text='Inactive' color='#ffd800' /> : obj.is_approved && obj.is_approved === 'APPROVED' ? <div className={classes.link} onClick={() => resendInvite(obj)}>{'Resend Invite?'}</div> : obj.is_approved && obj.is_approved === 'REJECTED' ? <StatusButton text='Rejected' color='#FF6565' /> : <StatusButton text='Pending' color='#ffd800' />,
        },
      ]
      userTable.push(tableObj)
    })
    setTableData(userTable)
  }

  const resendInvite = (obj) => {
    setLoading(true)
    const { currentUser } = props
    userService.resendInvite(currentUser.account_id, obj.email)
      .then(resendInviteData => {
        setOpen(true)
        setMessage(resendInviteData)
        setMessageType(messageTypes.SUCCESS)
        setLoading(false)
      })
      .catch(error => {
        setMessage(
          _.get(
            error,
            'data.error.displayMessage',
            'Failed to send invite',
          ),
        )
        setMessageType(messageTypes.ERROR)
        setOpen(true)
        setLoading(false)
      })
  }

  const getDialogContent = () => (
    <>
      <form onSubmit={formik.handleSubmit}>
        {props.isSuperAdmin && (!editData || showAccount) ?
          <TextField
            id="account_name"
            className={classes.marginY}
            name="account_id"
            label="Account Name"
            select
            disabled={props.isViewOnly}
            value={formik.values.account_id}
            onChange={formik.handleChange}
            InputProps={{
              classes: { root: classes.input }
            }}
            SelectProps={{
              MenuProps: {
                classes: { paper: classes.paper },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left"
                },
                getContentAnchorEl: null
              }
            }}
            fullWidth
            error={formik.touched.account_id && Boolean(formik.errors.account_id)}
            helperText={formik.touched.account_id && formik.errors.account_id}
          >
            {accounts.map(account => (
              <MenuItem value={_.get(account, 'id', '')}>{_.get(account, 'company_name', 'NA')}</MenuItem>
            ))}
          </TextField> : ''
        }
        <TextField
          id="name"
          className={classes.marginY}
          name="name"
          label="Name"
          disabled={props.isViewOnly}
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={(e) => formik.setFieldValue('name', e.target.value.trim())}
          fullWidth
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
        />
        <TextField
          id="role"
          className={classes.marginY}
          name="role"
          label="User Role"
          disabled={props.isViewOnly}
          select
          value={formik.values.role}
          onChange={(e) => {
            if (editData && editData.roles.includes('SUPER_ADMIN') && (e.target.value === ACCOUNT_ADMIN || e.target.value === ACCOUNT_USER)) {
              setShowAccount(true)
              formik.setFieldValue('account_id', '')
            } else {
              setShowAccount(false)
            }
            formik.setFieldValue('role', e.target.value)
          }}
          InputProps={{
            classes: { root: classes.input }
          }}
          SelectProps={{
            MenuProps: {
              classes: { paper: classes.paper },
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              getContentAnchorEl: null
            }
          }}
          fullWidth
          error={formik.touched.role && Boolean(formik.errors.role)}
          helperText={formik.touched.role && formik.errors.role}
        >
          {props.isSuperAdmin && <MenuItem value={SUPER_ADMIN} disabled>Super Admin</MenuItem>}
          <MenuItem value={ACCOUNT_ADMIN}>Admin</MenuItem>
          <MenuItem value={ACCOUNT_USER}>User</MenuItem>
        </TextField>
        <TextField
          id="email"
          className={classes.marginY}
          name="email"
          label="Email Address"
          type="email"
          disabled={editData}
          value={formik.values.email}
          onChange={(e) => formik.setFieldValue('email', e.target.value.trim())}
          fullWidth
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />
        <TextField
          id="phone"
          className={classes.marginT}
          name="phone"
          label="Phone"
          disabled={props.isViewOnly}
          value={formik.values.phone}
          onChange={(e) => formik.setFieldValue('phone', e.target.value.trim())}
          fullWidth
          error={formik.touched.phone && Boolean(formik.errors.phone)}
          helperText={formik.touched.phone && formik.errors.phone}
        />
        {!props.isViewOnly && 
          <>
            <Typography style={{ margin: '20px 0 0' }}>
              I have consent for all enrolled sites to provide personal information to this user, and I have permission from this user to provide their personal information. Review Enphase's&nbsp;
              <a href="https://enphase.com/privacy" target="_blank" className={classes.privacyPolicy}>Privacy Policy</a>&nbsp;here.
            </Typography>
            <Box className={classes.modalButton}>
              <AppButton type="submit" text="Submit" />
            </Box>
          </>
        }
      </form>
    </>
  )

  const getAllAccounts = (account_id) => {
    setLoading(true)
    accountService.getAllAccounts(account_id)
      .then(accountsData => {
        setAccounts(accountsData)
        setLoading(false)
      })
      .catch(error => {
        setMessage(
          _.get(
            error,
            'data.error.displayMessage',
            'Failed to get accounts',
          ),
        )
        setMessageType(messageTypes.ERROR)
        setOpen(true)
        setLoading(false)
      })
  }

  useEffect(() => {
    if (props.isSuperAdmin) {
      getAllAccounts(props.currentUser.account_id)
    }
  }, [])

  useEffect(() => {
    if (!addUserModal) {
      formik.resetForm()
    }
  }, [addUserModal])

  useEffect(() => {
    getAllUsers(props.currentUser.account_id, page, rowsPerPage, sortBy, sortOrder)
  }, [page, rowsPerPage, sortBy, sortOrder])

  const handleClickOpen = () => {
    setEditData('')
    setAddUserModal(true)
  }

  const handleClose = () => {
    setAddUserModal(false)
    setShowAccount(false)
  }

  const handleMessageClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpen(false)
  }

  const handleSortData = (sortedObj) => {
    const modifiedObj = _.cloneDeep(headings)
    modifiedObj.forEach((obj, index) => {
      if (obj.id === sortedObj.id && obj.isSortable) {
        modifiedObj[index].sortOrder =
          obj.sortOrder === SORTORDER.ASC ? SORTORDER.DESC : SORTORDER.ASC
      } else {
        modifiedObj[index].sortOrder = SORTORDER.ASC
      }
    })
    const selectedObj = modifiedObj.find((obj) => sortedObj.id === obj.id)
    const selectedSortOrder = selectedObj.sortOrder === SORTORDER.ASC ? SORTORDER.ASC : SORTORDER.DESC
    setLoading(true)
    setPage(1)
    setSortBy(sortedObj.id)
    setSortOrder(selectedSortOrder)
    setHeadings(modifiedObj)
  }

  return (
    <Box>
      <Loader loading={loading} />
      <DisplayMessage
        open={open}
        message={message}
        messageType={messageType}
        handleClose={handleMessageClose}
      />
      <CustomDialog open={addUserModal} title={editData ? 'User Details' : 'Add New User'} handleClose={handleClose} content={getDialogContent()} />
      <Box className={classes.userHeaderWrapper}>
        {!props.isViewOnly && (props.isSuperAdmin || props.isAdmin) ?
          <OutlinedButton label="Add New User" onClick={handleClickOpen} /> : ''
        }
      </Box>
      <TableOutline
        tableHeadings={headings}
        tableData={tableData}
        totalElement={totalCount}
        loading={tableLoading}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handlePageChange}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        pagination
        handleSortData={handleSortData}
      />
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser, isSuperAdmin, isAdmin, isViewOnly } = auth
  return { authUser, currentUser, isSuperAdmin, isAdmin, isViewOnly }
}

const mapDispatchToProps = dispatch => ({
  getCurrentUser: payload => dispatch(getCurrentUser(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(Users)
